var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-expansion-panels",
    {
      attrs: { flat: "", accordion: "", multiple: "" },
      model: {
        value: _vm.panel,
        callback: function($$v) {
          _vm.panel = $$v
        },
        expression: "panel"
      }
    },
    [
      _c(
        "display-expansion-panel",
        [
          _c(
            "display-expansion-panel-header",
            { staticClass: "text-uppercase info--text" },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.generateMessage(
                      "properties_360.titles.contract_business"
                    )
                  ) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c("v-expansion-panel-content", [
            _c("div", { staticClass: "d-flex" }, [
              _c(
                "div",
                {
                  staticClass: "pa-2 font-weight-bold",
                  staticStyle: { width: "50%" }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.generateMessage("properties_360.titles.contract")
                      ) +
                      ":\n          "
                  ),
                  _c("custom-simple-table", {
                    attrs: {
                      item: _vm.property.contractual_commitment,
                      "i18-path":
                        "properties_360.fields.contractual_commitment",
                      "table-keys": [
                        "contract_reference",
                        "contract_reference_name",
                        "contract_startdate",
                        "contract_enddate",
                        "engagement_type",
                        "services_type"
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c("custom-simple-table", {
                    attrs: {
                      item: _vm.property.usage,
                      "i18-path": "properties_360.fields.usage",
                      "table-keys": ["market_type"]
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "pa-2 font-weight-bold",
                  staticStyle: { width: "50%" }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.generateMessage("properties_360.titles.business")
                      ) +
                      ":\n          "
                  ),
                  _c("custom-simple-table", {
                    staticClass: "px-2",
                    attrs: {
                      item: _vm.property.business,
                      "i18-path": "properties_360.fields.business",
                      "table-keys": ["id", "name"]
                    }
                  })
                ],
                1
              )
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "display-expansion-panel",
        [
          _c(
            "display-expansion-panel-header",
            { staticClass: "text-uppercase info--text" },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.generateMessage("properties_360.titles.property")
                  ) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c("v-expansion-panel-content", [
            _c(
              "div",
              { staticClass: "d-flex flex-wrap" },
              [
                _c("display-checkbox", {
                  staticClass: "ma-2",
                  attrs: {
                    label: _vm.generateMessage(
                      "properties_360.fields.active_enabled"
                    ),
                    "input-value": _vm.property.active_enabled
                  }
                }),
                _vm._v(" "),
                _c("display-checkbox", {
                  staticClass: "ma-2",
                  attrs: {
                    label: _vm.generateMessage(
                      "properties_360.fields.m2m_remotemanagement_enabled"
                    ),
                    "input-value": _vm.property.m2m_remotemanagement_enabled
                  }
                }),
                _vm._v(" "),
                _c("display-checkbox", {
                  staticClass: "ma-2",
                  attrs: {
                    label: _vm.generateMessage(
                      "properties_360.fields.usage.gtb_enabled"
                    ),
                    "input-value": _vm.property.usage.gtb_enabled
                  }
                }),
                _vm._v(" "),
                _c("display-checkbox", {
                  staticClass: "ma-2",
                  attrs: {
                    label: _vm.generateMessage(
                      "properties_360.fields.gmao_enabled"
                    ),
                    "input-value": _vm.property.gmao_enabled
                  }
                }),
                _vm._v(" "),
                _c("display-checkbox", {
                  staticClass: "ma-2",
                  attrs: {
                    label: _vm.generateMessage(
                      "properties_360.fields.surf_plannable"
                    ),
                    "input-value": _vm.property.surf_plannable
                  }
                }),
                _vm._v(" "),
                _c("display-checkbox", {
                  staticClass: "ma-2",
                  attrs: {
                    label: _vm.generateMessage(
                      "properties_360.fields.usage.planon_enabled"
                    ),
                    "input-value": _vm.property.usage.planon_enabled
                  }
                }),
                _vm._v(" "),
                _c("display-checkbox", {
                  staticClass: "ma-2",
                  attrs: {
                    label: _vm.generateMessage(
                      "properties_360.fields.contractual_commitment.preventive_ordo"
                    ),
                    "input-value":
                      _vm.property.contractual_commitment.preventive_ordo
                  }
                }),
                _vm._v(" "),
                _c("display-checkbox", {
                  staticClass: "ma-2",
                  attrs: {
                    label: _vm.generateMessage(
                      "properties_360.fields.contractual_commitment.request_ordo"
                    ),
                    "input-value":
                      _vm.property.contractual_commitment.request_ordo
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex" },
              [
                _c("custom-simple-table", {
                  staticClass: "pa-2",
                  staticStyle: { width: "50%" },
                  attrs: {
                    item: _vm.property,
                    "i18-path": "properties_360.fields",
                    "table-keys": [
                      "code",
                      "name",
                      "shortname",
                      "address",
                      "access_information",
                      "door_code"
                    ]
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "pa-2", staticStyle: { width: "50%" } },
                  [
                    _c("custom-simple-table", {
                      attrs: {
                        item: _vm.property.usage,
                        "i18-path": "properties_360.fields.usage",
                        "table-keys": ["purpose", "area_m2", "sizing_lib"]
                      }
                    }),
                    _vm._v(" "),
                    _c("custom-simple-table", {
                      attrs: {
                        item: _vm.property,
                        "i18-path": "properties_360.fields",
                        "table-keys": ["observation", "reminder"]
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "display-expansion-panel",
        [
          _c(
            "display-expansion-panel-header",
            { staticClass: "text-uppercase info--text" },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.generateMessage("properties_360.titles.workforce")
                  ) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c("v-expansion-panel-content", [
            _c("div", { staticClass: "d-flex" }, [
              _c(
                "div",
                { staticStyle: { width: "50%" } },
                [
                  _c("custom-simple-table", {
                    staticClass: "px-2",
                    attrs: {
                      item: _vm.property,
                      "i18-path": "properties_360.fields",
                      "table-keys": [
                        "mnt_responsible_technician",
                        "mnt_responsible_phone"
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c("custom-simple-table", {
                    staticClass: "px-2",
                    attrs: {
                      item: _vm.usage,
                      "i18-path": "properties_360.fields",
                      "table-keys": ["maintenance_hourly_account"]
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { width: "50%" } },
                [
                  _c("custom-simple-table", {
                    staticClass: "px-2",
                    attrs: {
                      item: _vm.property,
                      "i18-path": "properties_360.fields",
                      "table-keys": ["mnt_resp_buddy", "mnt_resp_buddy_phone"]
                    }
                  }),
                  _vm._v(" "),
                  _c("custom-simple-table", {
                    staticClass: "px-2",
                    attrs: {
                      item: _vm.usage,
                      "i18-path": "properties_360.fields",
                      "table-keys": ["global_hourly_account"]
                    }
                  })
                ],
                1
              )
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "display-expansion-panel",
        [
          _c(
            "display-expansion-panel-header",
            { staticClass: "text-uppercase info--text" },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.generateMessage(
                      "properties_360.titles.service_location"
                    )
                  ) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "v-expansion-panel-content",
            [
              _c("v-data-table", {
                staticClass: "secondarybackground no-hover",
                attrs: {
                  dense: "",
                  "no-data-text": "Aucun lieu associé à cette installation",
                  headers: _vm.locationHeaders,
                  items: _vm.location,
                  "disable-pagination": "",
                  "hide-default-footer": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.adress",
                    fn: function({ item }) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm._f("showAdress")(item)) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "display-expansion-panel",
        [
          _c(
            "display-expansion-panel-header",
            { staticClass: "text-uppercase info--text" },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.generateMessage("properties_360.titles.contacts")
                  ) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c("v-expansion-panel-content", [
            _c(
              "div",
              { staticClass: "bordered-element pa-2 mb-5" },
              [
                _c("div", { staticClass: "font-weight-bold" }, [
                  _vm._v("\n          Interlocuteurs Cofely\n        ")
                ]),
                _vm._v(" "),
                _c(
                  "v-simple-table",
                  {
                    staticClass: "secondarybackground caption",
                    attrs: { dense: "" }
                  },
                  [
                    _c("thead", [
                      _c("tr", [
                        _c("th"),
                        _vm._v(" "),
                        _c("th", [_vm._v("Nom")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Téléphone")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Email")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tbody", [
                      _c("tr", [
                        _c("td", [_vm._v("Responsable en charge du contrat")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(_vm.property.maintenance.administrator_name)
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(_vm.property.maintenance.administrator_phone)
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(_vm.property.maintenance.administrator_mail)
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("Responsable d'équipe")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm.property.maintenance.entity_in_charge_name
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm.property.maintenance.entity_in_charge_phone
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm.property.maintenance.entity_in_charge_mail
                            )
                          )
                        ])
                      ])
                    ])
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "bordered-element pa-2" },
              [
                _c("div", { staticClass: "font-weight-bold" }, [
                  _vm._v("\n          Interlocuteurs du site\n        ")
                ]),
                _vm._v(" "),
                _c("v-data-table", {
                  staticClass: "secondarybackground",
                  attrs: {
                    dense: "",
                    "no-data-text":
                      "Aucun contact associé à cette installation",
                    headers: _vm.contactsHeaders,
                    items: _vm.contacts,
                    "disable-pagination": "",
                    "disable-sort": "",
                    "hide-default-footer": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item.name",
                      fn: function({ item }) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.gender) +
                              " " +
                              _vm._s(item.firstname) +
                              " " +
                              _vm._s(item.lastname) +
                              "\n          "
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }